export default "__VITE_ASSET__DVGcJfrh__"